import React, { useState, useEffect } from 'react';
import DropdownInput from 'components/Dropdown/Dropdown';
import CancelIcon from '@material-ui/icons/Cancel';
import FilterOptionRange from './FilterOptionRange';

interface FilterOptionNestedRangeProps {
  options: any;
  label: string;
  field: string; // key for pushing up the values
  selectedValue: any;
  onChange: Function; // Function to handle changes in min and max values
}

const FilterOptionNestedRange = ({
  options,
  label,
  field,
  selectedValue = {},
  onChange
}: FilterOptionNestedRangeProps) => {
  const [selected, setSelected] = useState<string[]>(
    Array.isArray(selectedValue) ? selectedValue : []
  );
  const [childItems, setChildItems] = useState<any>({});
  const [value, setValue] = useState('');
  const dropdownOptions = Object.keys(options);

  const handleRemove = (option: string) => {
    setSelected(prevSelected => prevSelected.filter(item => item !== option));

    setChildItems((prev: any) => {
      const updatedItems = { ...prev };
      delete updatedItems[option];
      return updatedItems;
    });
  };

  const handleSelect = (option: string) => {
    if (option) {
      const nestedOption = options[option];
      if (!selected.includes(nestedOption)) {
        const newSelected = [...selected, nestedOption];
        setSelected(newSelected);
        setValue(nestedOption);
      }
    }
  };

  const handleFilterChange = (filterName: string, selectedValue: string) => {
    if (selected.includes(filterName)) {
      setChildItems((prevFilters: any) => ({
        ...prevFilters,
        [filterName]: selectedValue || undefined
      }));
    }
  };

  const getLabel = (option: string) => {
    return Object.keys(options).find(key => options[key] === option) || '';
  };

  useEffect(() => {
    onChange(field, childItems);
  }, [childItems]);

  useEffect(() => {
    setSelected(Object.keys(selectedValue));
  }, [selectedValue]);

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'top' }}
    >
      <div style={{ width: '100%' }}>
        <DropdownInput
          options={
            dropdownOptions &&
            dropdownOptions
              .filter(option => !!option)
              .map((option: any) => ({
                name: option
              }))
          }
          label={`Select ${label}`}
          onChange={(e: any) => handleSelect(e.name)}
          objectKey={'name'}
          search={true}
          value={value}
          clearValue
        />

        {Array.isArray(selected) && selected.length > 0 && (
          <div
            style={{
              display: 'inline-flex',
              gap: '.5rem',
              marginTop: '.5rem',
              flexWrap: 'wrap'
            }}
          >
            {selected.map(item => (
              <div
                key={item}
                style={{
                  display: 'inline-flex',
                  alignItems: 'baseline',
                  gap: '1rem',
                  padding: '.2rem .5rem',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  backgroundColor: '#f0f0f0'
                }}
              >
                <div style={{ width: '100%', display: 'flex', gap: '1rem' }}>
                  <FilterOptionRange
                    label={`${getLabel(item)} (%)`}
                    field={item}
                    onChange={(filterName: string, selectedValue: string) =>
                      handleFilterChange(filterName, selectedValue)
                    }
                    selectedValue={Object.values(selectedValue)[0]}
                    nested
                  />
                </div>
                <CancelIcon
                  style={{ fontSize: '1rem', cursor: 'pointer' }}
                  onClick={() => handleRemove(item)} // Handle removal of selected item
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterOptionNestedRange;
